import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OffersPage from './components/OffersPage';
import ReferPage from './components/Refer';
import Offer from './components/Offer';
import Track from './components/TrackLead';
import AdminPanel from './admin/Dashboard';
import GeneralSettings from './admin/SettingsPage';
import LoginPage from './admin/LoginPage';
import PerformancePage from './admin/Performance';
import OfferWisePage from './admin/OfferWisePage';
import ConversionPage from './admin/ConversionPage';
import GatewaySettings from './admin/GatewayPage';
import WhitelistIPPage from './admin/WhitelistIPPage';
import BanPage from './admin/BanPage';
import PostbackPage from './admin/PostbackPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<OffersPage />} />
        <Route path="/Refer-Earn" element={<ReferPage />} />
        <Route path="/offer/:offerId/:refer?" element={<Offer />} />
        <Route path="/track" element={<Track />} />
        <Route path="/adminBT" element={<AdminPanel />} />
        <Route path="/adminBT/settings" element={<GeneralSettings />} />
        <Route path="/adminBT/login" element={<LoginPage />} />
        <Route path="/adminBT/performance" element={<PerformancePage />} />
        <Route path="/adminBT/offerWise" element={<OfferWisePage />} />
        <Route path="/adminBT/conversion" element={<ConversionPage />} />
        <Route path="/adminBT/gateway" element={<GatewaySettings />} />
        <Route path="/adminBT/whitelistIp" element={<WhitelistIPPage />} />
        <Route path="/adminBT/ban" element={<BanPage />} />
        <Route path="/adminBT/postback" element={<PostbackPage />} />
        {/* Add other routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;